import script from "./ButtonAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonAudit.vue?vue&type=script&setup=true&lang=js"

import "./ButtonAudit.vue?vue&type=style&index=0&id=4ce626ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce626ba"]])

export default __exports__